import { render, staticRenderFns } from "./SwImagePlaceholder.vue?vue&type=template&id=36c9ca5d"
import script from "./SwImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./SwImagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./SwImagePlaceholder.vue?vue&type=style&index=0&id=36c9ca5d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports